import * as React from 'react';

/* tslint:disable */
const SvgIconDone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 512 512" {...props}>
    <path
      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 48A200 200 0 1 1 56 256 199.89 199.89 0 0 1 256 56m140.2 130.27l-22.53-22.72a12 12 0 0 0-17-.07L215.35 303.7l-59.8-60.28a12 12 0 0 0-17-.07l-22.72 22.54a12 12 0 0 0-.06 17l90.78 91.51a12 12 0 0 0 17 .07l172.59-171.2a12 12 0 0 0 .06-17z"
      fill="#fff"
    />
  </svg>
);
/* tslint:enable */

export default SvgIconDone;

